import { Navigate, useNavigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import Login from './pages/Login';
import NotFound from './pages/Page404';
import Register from './pages/Register';
import DashboardApp from './pages/DashboardApp';
import VehicleOverview from './pages/VehicleOverview';
import Bookings from './pages/Bookings';
import Cancellations from './pages/Cancellation';
import Revenue from './pages/Revenue';
import Account from './pages/Account';
import ParkingDetails from './pages/ParkingDetails';  
import AuthLogout from './sections/auth/AuthLogout';
import ParkingSpots from './pages/ParkingSpots';
import MyParkingStatus from './pages/MyParkingStatus';
import TestingComponent from './components/TestingComponent';
import TestingPurpose from './components/TestingPurpose';
import TestingApi from './components/TestingApi';
import AllParkingSpaces from './pages/admin/AllParkingSpaces';
import VendorDetails from './pages/admin/VendorDetails';
import NewParkingRequests from './pages/admin/NewParkingRequests';
import AllBookings from './pages/admin/AllBookings';
import AllCancellations from './pages/admin/AllCancellations';
import ReviewParkingDetails from './pages/admin/ReviewParkingDetails';
import AddVendor from './pages/admin/AddVendor';
import { ParkingForm } from './sections/@dashboard/parkingspaces';
import ViewParkingDetails from './pages/admin/ViewParkingDetails';
import MyParkingDetails from './pages/MyParkingDetails';
import VendorParkingSpots from './pages/admin/VendorParkingSpots';
import CustomerDetails from './pages/admin/CustomerDetails';
import QRCodeScanner from './pages/QRCodeScanner';
import Offers from './pages/admin/Offers';
import WalletManagement from './pages/admin/WalletManagement';
import CommissionManagement from './pages/admin/CommissionManagement';
import VendorFlagging from './pages/admin/VendorFlagging';  
import AddWallet from './pages/admin/AddWallet';
import AddCommission from './pages/admin/AddCommission';
import Cities from './pages/admin/Cities';
import ServiceType from './pages/admin/serviceType';
import AddOrUpdateCity from './components/AddOrUpdateCity';
import AddOrUpdateService from './components/AddOrUpdateService';
import AddOrUpdateOffers from './components/AddOrUpdateOffers';
import AddOrUpdateCustomer from './components/AddOrUpdateCustomer';
import AdminRevenue from './pages/admin/AdminRevenue';
import RevenueDetails from './pages/admin/RevenueDetails';
import DashboardAdminApp from './pages/admin/DashboardAdminApp';
import ViewRequests from './pages/admin/ViewReuests';
import ResetPassword from './pages/admin/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import BlackoutDay from './pages/admin/BlackoutDay';
import UserManagement from './pages/admin/UserManagement';
import AddUser from './pages/admin/AddUser';
import RoleManagement from './pages/admin/RoleManagement';
import AddRole from './pages/admin/AddRole';
import ParkingWiseData from './pages/ParkingWiseData';
import Statistics from './pages/Statistics ';
import ParkingWiseDataForAdmin from './pages/admin/ParkingWiseDataForAdmin';
import AdminStatistics from './pages/admin/AdminStatistics';
import Blog from './pages/admin/Blog';
import AddBlog from './components/AddBlog';
import Notes from './pages/admin/Notes';
import CustomerSupport from "./pages/admin/CustomerSupport";
import AddNotes from './components/AddNotes';
import BookingDetails from './pages/BookingDetails';
import Success from './pages/Success';
import UnsuccessfulError from './pages/UnsuccessfulError';
import { useEffect, useState } from 'react';
import { useAppSelector } from './store/hooks';
import { getAuthDetails } from './store/state/authSlice';
import { useGetAllBookingDetailBySearchCriteriaMutation } from './store/api/bookingsApi';
import toast from 'react-hot-toast';
import EnforcementQRScan from './pages/admin/EnforcementQRScan';
import CreateNewBooking from './pages/admin/CreateBooking';
import AddPaymentGetaway from './components/AddorUpdatePaymentGetaway';
import PaymentGetaway from './pages/admin/PaymentGetaway';
import WebCamPage from './pages/WebCamPage';
import PosDevice from './pages/admin/PosDevice';
import AddOrUpdatePosDevice from './pages/admin/AddOrUpdatePosDevice';
import UserLogout from './sections/auth/userLogin';
import DriverDetails from './pages/admin/DriverDetails';
import AddDriver from './pages/admin/AddDriver';
import Testimonial from './pages/admin/Testimonials';

export default function Router() {
  const userType = JSON.parse(localStorage.getItem('login') || '{}').userType;
  const navigate = useNavigate();
  const authUserData = useAppSelector(getAuthDetails);
  const localUserObj = JSON.parse(localStorage.getItem('login') || '{}')
  const token: any = JSON.parse(localStorage.getItem('login') || '{}').token;
  const [getAllBookingDetailBySearchCriteria, getAllBookingResponse] = useGetAllBookingDetailBySearchCriteriaMutation();
  const [customerName, setcustomerName] = useState('');

  useEffect(() => {
    if (localUserObj) {
      if (localUserObj.userType === "UTSA") {
        getAllBookingDetailBySearchCriteria({
          token: token,
          payload: {
            offset: 5,
            page: 0,
            orderBy: 'asc',
            name: 'id',
            customerName: customerName,
            flag: 'CURRENT_BOOKING',
          },
        });
      } else if (localUserObj.userType === "UTSP") {
        getAllBookingDetailBySearchCriteria({
          token: token,
          payload: {
            offset: 5,
            page: 0,
            orderBy: 'asc',
            name: 'id',
            serviceProviderId: localUserObj.serviceProviderId,
            flag: 'CURRENT_BOOKING',
          },
        });
      } else if (localUserObj.userType === "UTLB") {
        getAllBookingDetailBySearchCriteria({
          token: token,
          payload: {
            offset: 5,
            page: 0,
            orderBy: 'asc',
            name: 'id',
            id: localUserObj.id,
            flag: 'CURRENT_BOOKING',
          },
        });
      }

    }
  }, [authUserData]);

  useEffect(() => {
    if (getAllBookingResponse.isError) {
      const error: any = getAllBookingResponse?.error
      if (error.status == 401) {
        navigate("/logout", { replace: true });
        localStorage.clear();
        // toast.error('Session expired. Please login again.');
      }
    }
  }, [getAllBookingResponse.isError])

  const vendorRoutes = [
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { path: 'app', element: <DashboardApp /> }, 
        { path: 'bookings', element: <Bookings /> },
        { path: 'booking-details', element: <BookingDetails /> },
        { path: 'vehicle-overview', element: <VehicleOverview /> },
        { path: 'webcam', element: <WebCamPage /> },
        { path: 'driver-details', element: <DriverDetails /> },
        { path: 'add-driver', element: <AddDriver /> },
        { path: 'myvehiclestatus/:parkingId', element: <MyParkingDetails /> },
        { path: 'myvehiclestatus', element: <MyParkingStatus /> },
        { path: 'vehiclewisedata', element: <ParkingWiseData /> },
        { path: 'statistics', element: <Statistics /> },
        { path: 'cancellations', element: <Cancellations /> },
        { path: 'revenue', element: <Revenue /> },
        { path: 'account', element: <Account /> },
        { path: 'parkingdetails', element: <ParkingDetails /> },
        { path: 'parking-spots', element: <ParkingSpots /> },
        { path: 'addvehicle', element: <ParkingForm /> },
        { path: 'testingapi', element: <TestingComponent /> },
        { path: 'testingpurpose', element: <TestingPurpose /> },
        { path: 'bookingapi', element: <TestingApi /> },
        { path: 'scan', element: <QRCodeScanner /> },
        { path: 'reset-password', element: <ResetPassword /> },
        { path: 'user-management', element: <UserManagement /> },
        { path: 'add-user', element: <AddUser /> },
        { path: 'QR-details', element: <EnforcementQRScan /> },
        { path: 'create-new-booking', element: <CreateNewBooking /> },
     
      ],
    },
  ];

  const driverRoutes = [
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { path: 'app', element: <DashboardApp /> }, 
        { path: 'bookings', element: <Bookings /> },
        { path: 'booking-details', element: <BookingDetails /> },
        { path: 'account', element: <Account /> },
      ],
    },
  ];

  const adminRoutes = [
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { path: 'app', element: <DashboardAdminApp /> },
        { path: 'all-vehicle-spaces', element: <AllParkingSpaces /> },
        { path: 'service-type', element: <ServiceType /> },
        { path: 'add-or-update-servivce', element: <AddOrUpdateService /> },
        { path: 'all-vehicle-spaces/:parkingId', element: <ViewParkingDetails /> },
        { path: 'parking-spots', element: <VendorParkingSpots /> },
        { path: 'addvehicle', element: <ParkingForm /> },
        { path: 'testingapi', element: <TestingComponent /> },
        { path: 'vendor-details', element: <VendorDetails /> },
        { path: 'driver-details', element: <DriverDetails /> },
        { path: 'user-management', element: <UserManagement /> },
        { path: 'add-user', element: <AddUser /> },
        { path: 'role-management', element: <RoleManagement /> },
        { path: 'add-role', element: <AddRole /> },
        { path: 'reset-password', element: <ResetPassword /> },
        { path: 'add-vendor', element: <AddVendor /> },
        { path: 'add-driver', element: <AddDriver /> },
        { path: 'new-vehicle-requests', element: <NewParkingRequests /> },
        { path: 'view-request', element: <ViewRequests /> },
        { path: 'review-parking-details', element: <ReviewParkingDetails /> },
        { path: 'all-bookings', element: <AllBookings /> },
        { path: 'all-cancellations', element: <AllCancellations /> },
        { path: 'admin-revenue', element: <AdminRevenue /> },
        { path: 'notes', element: <Notes /> },
        { path: 'blogs', element: <Blog /> },
        { path: 'add-or-update-blog', element: <AddBlog /> },
        { path: 'add-notes', element: <AddNotes /> },
        { path: 'revenue-details', element: <RevenueDetails /> },
        { path: 'customer-details', element: <CustomerDetails /> },
        { path: 'customer-support', element: <CustomerSupport /> },
        { path: 'cities', element: <Cities /> },
        { path: 'add-or-update-city', element: <AddOrUpdateCity /> },
        { path: 'add-or-update-offers', element: <AddOrUpdateOffers /> },
        { path: 'add-or-update-customer', element: <AddOrUpdateCustomer /> },
        { path: 'offers', element: <Offers /> },
        { path: 'wallet-management', element: <WalletManagement /> },
        { path: 'add-wallet', element: <AddWallet /> },
        { path: 'commission-management', element: <CommissionManagement /> },
        { path: 'add-commission', element: <AddCommission /> },
        { path: 'vendor-flagging', element: <VendorFlagging /> },
        { path: 'vehicle-wise-data-for-admin', element: <ParkingWiseDataForAdmin /> },
        { path: 'blackout-day', element: <BlackoutDay /> },
        { path: 'booking-details', element: <BookingDetails /> },
        { path: 'admin-statistics', element: <AdminStatistics /> },
        { path: 'add-Payment-method', element: <AddPaymentGetaway /> },
        { path: 'payments-method', element: <PaymentGetaway /> },
        { path: 'pos-device', element: <PosDevice /> },
        { path: 'add-or-update-pos-device', element: <AddOrUpdatePosDevice /> },
        { path: 'testimonial', element: <Testimonial /> },
      ],
    },
  ];

const dynamicRoutes = userType === 'UTSA'
  ? adminRoutes
  : userType === 'UTSP'
  ? vendorRoutes
  : userType === 'UTLB'
  ? driverRoutes
  : [];

  return useRoutes([
    ...dynamicRoutes,
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: '/', element: <Navigate to="/login" /> },
        { path: '/dashboard/', element: <Navigate to="/dashboard/app" /> },
        { path: 'login', element: <Login /> },
        { path: 'success', element: <Success /> },
        { path: 'error', element: <UnsuccessfulError /> },
        { path: '/login/forget-password', element: <ForgotPassword /> },
        { path: 'logout', element: <AuthLogout /> },
        { path: 'user-logout', element: <UserLogout /> },
        { path: 'register', element: <Register /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);

}
